import { getLocaleFromPath } from '@/shared/api/client/base';

interface CategoryFilterItemProps<T> {
  item: T;
  isSelected: boolean;
  label: string;
  onClick?: (item: T) => void;
}

const PcCategoryFilterItem = <T,>({
  item,
  isSelected,
  label,
  onClick,
}: CategoryFilterItemProps<T>) => {
  const locale = getLocaleFromPath();
  const fontSize = () => {
    return locale === 'en-US' ? 'text-[12px]' : 'text-[18px]';
  };
  const color = isSelected
    ? 'bg-primary-600 text-secondary-white rounded-[30px]'
    : 'text-[#848484]';

  return (
    <span
      className={`text-[#848484] font-semibold px-[24px] py-[16px] max cursor-pointer ${color} ${fontSize}`}
      onClick={() => onClick?.(item)}
    >
      {label}
    </span>
  );
};

export default PcCategoryFilterItem;
